import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {Link} from 'gatsby';

function Solution(props) {
    return (
        <div className="services_solution  p-100">
            <Container>
                <Row>
                    <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
                        <div className="example" data-text="Tech Revolution">
                            <h2>Equipping Your Business For The Technology Revolution Through Proper Data Analytics
                                Solutions</h2>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="offset-lg-1">
                        <p>TekRevol helps equip your business with modern technology requirements. From raw data to
                            refined information, we keep everything under consideration to deliver you what you need.
                            With the right approach, TekRevol’s team ensures you the likely results. </p>
                        <p>We power your data management needs with complete infrastructure built to comply with your
                            modern warehousing and storage needs. TekRevol’s data experts enable you to accelerate your
                            performance and reduce unwanted delays from servers to the complete ecosystem.</p>
                        <Link to="/contact"
                              className="border_btn" aria-label="TekRevol Contact">Let's Connect!</Link>
                    </Col>

                </Row>
            </Container>
        </div>
    );
}

export default Solution;